import { Component } from '@angular/core';

@Component({
    selector: 'app-connecting-animation',
    templateUrl: './connecting-animation.component.html',
    styleUrls: ['./connecting-animation.component.css'],
    standalone: false
})
export class ConnectingAnimationComponent {}
